import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

const ColumnTypeSchema = z.enum([
  "string",
  "integer",
  "float",
  "boolean",
  "date",
]);

const ColumnSnapshotSchema = z.object({
  name: z.string().min(1),
  type: ColumnTypeSchema,
});

const FrameCellValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export const statefulTableReadFrameStep = defineStepConfig({
  type: "stateful_table_read_frame",
  name: "Stateful Table Read Frame",
  description:
    "Read the latest frame from a stateful table, optionally filtered by per-column inputs (exact match, AND-joined). Outputs both CSV and a structured rows array.",
  category: "Data Access",

  inputSchema: z.record(z.string(), z.unknown()),

  outputSchema: z.object({
    csv: z.string(),
    rows: z.array(z.array(FrameCellValueSchema)),
    columns: z.array(z.string()),
    rowCount: z.number().int().min(0),
    frameNumber: z.number().int().min(1),
    versionNumber: z.number().int().min(1),
  }),

  configSchema: z.object({
    tableDefinitionId: z
      .string()
      .uuid()
      .describe("ID of the stateful table to read from"),
    columns: z
      .array(ColumnSnapshotSchema)
      .min(1)
      .describe(
        "Snapshot of the table's column schema at design time. Drives the per-column filter input sockets.",
      ),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "5 minutes",
    retry: { maximumAttempts: 2 },
  },
});
